import { MINUTES_IN_HOUR } from '../constants/time';
// dateToMinutes(new Date('2025-12-17T09:30:00')) -> 570
export const dateToMinutes = (date) => date.getHours() * MINUTES_IN_HOUR + date.getMinutes();
